// =============================================
// Author:      JUNAID HASSAN
// Create date: 2025-08-18
// Description: KSA mobile helpers for UI validation/normalization.
// =============================================

const digitsOnly = (s) => (s || '').replace(/\D+/g, '');

/** Normalize to canonical MSISDN "9665XXXXXXXX" (12 digits).
 *  Returns null if the input cannot be normalized to a valid KSA mobile.
 */
export function normalizeKsaMobile(value) {
  let d = digitsOnly(value);

  if (/^009665\d{8}$/.test(d)) d = d.slice(2);             // 00966 -> 966
  if (/^9660\d{9}$/.test(d)) d = '966' + d.slice(4);        // 9660XXXXXXXXX -> 966 + drop '0'

  if (/^9665\d{8}$/.test(d)) return d;                      // canonical
  if (/^05\d{8}$/.test(d))  return '966' + d.slice(1);      // 05XXXXXXXX
  if (/^5\d{8}$/.test(d))   return '966' + d;               // 5XXXXXXXX

  return null; // not a valid KSA mobile form
}

export function isValidKsaMobile(value) {
  if (!value) return true; // empty is allowed by caller; enforce "required" separately
  return !!normalizeKsaMobile(value);
}

/** Optional display formatter (kept plain as requested) */
export const fmtKsaMobile = (v) => normalizeKsaMobile(v) || (v || '');

/**
 * Normalize KSA phone and return object format { ok: boolean, normalized?: string }
 * This is a wrapper around normalizeKsaMobile to match the interface used in some components
 */
export function normalizeKsaPhone(input) {
  const normalized = normalizeKsaMobile(input);
  return normalized ? { ok: true, normalized } : { ok: false };
}

